import { StackTrace } from 'stacktrace-js';
/**** Global error logging *****/
export function errorHandler(message, source, lineno, colno, error) {
    if (error){
        var firstFrameIndex = 0;
      if (typeof error == 'string' || error instanceof String) {
        // Transform the message in an error, use try/catch to make sure the stacktrace is populated.
        try {
          throw new Error(error);
        } catch (e) {
          error = e;
        }
        // the first frame when using report() is always this library
        firstFrameIndex = 1;
      }
        StackTrace.fromError(error).then((stack)=>{
            var lines = [error.toString()];
            for (var s = firstFrameIndex; s < stack.length; s++) {
              // Cannot use stack[s].source as it is not populated from source maps.
              lines.push([
                '    at ',
                // If a function name is not available '<anonymous>' will be used.
                stack[s].getFunctionName() || '<anonymous>', ' (',
                stack[s].getFileName(), ':',
                stack[s].getLineNumber(), ':',
                stack[s].getColumnNumber(), ')',
              ].join(''));
            }
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/kms/ajaxlog/', true);
            // Fire an Ajax request with error details
            xhr.send(lines.join('\n'));
        });
    }


    //TODO: Display user an error notification to user?
}
